import { MedicalServices } from './MedicalServices';

export const MedicalServicesOlos = () => {
  return <MedicalServices contextType="OLOS" />;
};

export default MedicalServicesOlos;
